import { Button, withStyles } from '@material-ui/core';
import { ArrowForward } from '@material-ui/icons';

const styles = (theme) => ({
  actionButton: {
    textTransform: 'none',
    '&$actionDisabled': {
      backgroundColor: theme.headerIconColor,
      color: theme.TextColor,
      cursor: 'not-allowed',
      opacity: 0.7
    }
  },
  actionDisabled: {
    backgroundColor: theme.iconColor,
  },
  buttonText: {
    display: 'inherit',
    alignItems:'inherit',
  }
});
const NextOrCompleteButton = ({ onClick, disabled, classes, isLastStep }) => (
  <Button
    classes={{ root: classes.actionButton, disabled: classes.actionDisabled }}
    variant="contained"
    color="primary"
    onClick={onClick}
    disabled={disabled}>
   { isLastStep ? 'Complete': <span className={classes.buttonText}>Move to Next Step <ArrowForward /></span> }
  </Button>
);

export default withStyles(styles)(NextOrCompleteButton);
